import { isReadyStatus } from '#high-frequency-game/app/components/highFrequencyGameGuards'

export default defineNuxtRouteMiddleware(async (route) => {
  if (import.meta.server) return

  const { navigateToLocalized } = useRouterUtils()

  const orderId = String(route.params.id)
  const licensedTerritory = useLicensedTerritory({ raw: true })

  const cancel = () => navigateToLocalized(`/my-orders/keno/${orderId}`)

  const redirect = (drawNumber: string) =>
    navigateToLocalized(`/my-orders/keno/${orderId}/watch/${drawNumber}`)

  try {
    const response = await useHighFrequencyOrderDetailLazyQuery({
      licensedTerritory,
      orderId,
    }).load()

    if (!response) return cancel()

    const data = response.highFrequencyOrderDetail
    if (isGraphqlFailure(data)) return cancel()

    const readyDraw = data.draws.find(({ status }) => isReadyStatus(status))
    if (!readyDraw) return cancel()

    return redirect(String(readyDraw.number))
  } catch {
    return cancel()
  }
})
